<template>
  <div class="online-container">
    <img
      v-if="
        advertisements.filter(a => a.category && a.category.id == 7).length > 0
      "
      :src="
        advertisements.filter(a => a.category && a.category.id == 7)[0].picture
      "
      style="width: 100%; height: 350px"
      @click="
        handleAdvertisementClick(
          advertisements.filter(a => a.category && a.category.id == 7)[0]
        )
      "
    />
    <img
      v-else
      src="../assets/images/onlineshowheaderbg.png"
      style="width: 100%; height: 350px"
    />
    <div class="container">
      <div class="online-header row" v-if="!filters.key">
        <div class="online-header-list">
          <div
            v-for="(item, idx) in categories"
            :key="idx"
            :class="[
              'online-header-item',
              { onlineActive: category.id == item.id }
            ]"
            @click="handleItemClick(item)"
          >
            <div class="online-header-img">
              <img :src="item.icon" />
            </div>
            <p class="online-header-text">
              {{ $i18n.locale == "zh" ? item.name : item.nameEn }}
            </p>
          </div>
        </div>
        <div class="online-header-swiper">
          <el-carousel arrow="always" trigger="click" class="online-swiper">
            <el-carousel-item
              v-for="(item, idx) in advertisements.filter((a, i) => i > 0)"
              :key="idx"
            >
              <div
                class="row"
                @click="handleExhibitClick(item)"
                style="height: 100%; cursor: pointer"
              >
                <div class="online-header-left">
                  <div class="online-header-tag">
                    <!-- <img
                      class="online-icon-recom"
                      src="../assets/images/icon_recom.png"
                    /> -->
                    <div class="online-hot-view"></div>
                    <div class="online-hot-text">
                      {{ $i18n.locale == "zh" ? "热门推荐" : "Hot" }}
                    </div>
                    <img
                      class="online-icon-new"
                      src="../assets/images/icon_new.png"
                    />
                  </div>
                  <div style="width: 302px; height: 232px">
                    <img
                      v-if="
                        item.properties &&
                          item.properties.albums &&
                          item.properties.albums.length
                      "
                      class="online-swiper-img"
                      style="width: 100%"
                      :src="item.properties.albums[0]"
                      alt
                    />
                    <img
                      v-else
                      style="width: 100%"
                      :src="require('../assets/images/bike.png')"
                      alt=""
                    />
                  </div>
                </div>
                <div class="online-siper-detail">
                  <p class="online-siper-name">
                    {{ $i18n.locale == "zh" ? item.name : item.nameEn }}
                  </p>
                  <p class="online-siper-comp">
                    {{
                      $i18n.locale == "zh"
                        ? item.exhibitorName
                        : item.exhibitorNameEn
                    }}
                  </p>
                  <div class="row online-siper-btnlist">
                    <p v-if="false" @click.stop="handleInquiryClick(item)">
                      {{ $t("Inquiry1") }}
                    </p>
                    <p
                      v-if="item.collected"
                      style="background: #999999"
                      @click.stop="handleCollectClick('EXHIBIT', item.id, true)"
                    >
                      {{ $t("Favorited") }}
                    </p>
                    <p
                      v-else
                      @click.stop="
                        handleCollectClick('EXHIBIT', item.id, false)
                      "
                    >
                      {{ $t("Favorite") }}
                    </p>
                  </div>
                  <div class="online-swiper-line"></div>
                  <div class="online-siper-desc">
                    <p
                      v-if="item.description"
                      v-html="
                        $i18n.locale == 'zh'
                          ? item.description
                          : item.descriptionEn
                      "
                    ></p>
                    <p v-if="!item.description">
                      {{
                        $i18n.locale == "zh"
                          ? "暂无简介"
                          : "No introduction yet"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="row-between" style="padding: 30px 0" v-if="!filters.key">
        <div class="row">
          <div class="row online-sort">
            <el-radio-group
              fill="#619A37"
              text-color=""
              style="margin-right: 20px"
              size="mini"
              v-model="sorter.field"
              @change="handleParamChange"
            >
              <el-radio-button
                v-for="sort in sorters"
                :label="sort.value"
                :key="sort.value"
                >{{ sort.lable }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </div>
        <div class="row">
          <p class="online-sort-title">{{ $t("Hall") }}:</p>
          <el-select
            style="width: 200px"
            v-model="filters.venueId"
            :placeholder="$i18n.locale == 'zh' ? '请选择' : 'Please Select'"
            clearable
            @change="handleParamChange"
            @clear="filters.venueId = null"
          >
            <el-option
              v-for="item in venues"
              :key="item.id"
              :label="
                $i18n.locale == 'zh'
                  ? `${item.number || ''} ${item.name}`
                  : `${item.number || ''} ${item.nameEn}`
              "
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div>
        <div class="online-list">
          <div
            v-for="item in entities"
            :key="item.id"
            class="online-item column-between"
            @click="handleExhibitClick(item)"
          >
            <div class="online-item-top">
              <div class="online-item-img">
                <img
                  v-if="
                    item.properties &&
                      item.properties.albums &&
                      item.properties.albums.length
                  "
                  class="online-icon-recom"
                  :src="item.properties.albums[0]"
                />
                <img
                  v-else
                  :src="require('../assets/images/bike.png')"
                  alt=""
                />
              </div>
              <p class="online-item-name">
                <!-- :style="
                  ($i18n.locale == 'zh' ? item.name : item.nameEn).length > 18
                    ? 'line-height: 24px; padding: 0 30px; height:60px'
                    : ''
                " -->
                {{ $i18n.locale == "zh" ? item.name : item.nameEn }}
              </p>
            </div>
            <!--            新接口返回的exhibitor字段为空，先注释掉-->
            <p
              class="online-item-comp"
              :style="$i18n.locale == 'zh' ? '' : 'font-size: 12px;'"
            >
              {{
                $i18n.locale == "zh" ? item.exhibitorName : item.exhibitorNameEn
              }}
            </p>
          </div>
        </div>
        <el-pagination
          style="text-align: center; padding-bottom: 30px"
          background
          layout="prev, pager, next"
          :current-page="pagination.current"
          :page-size.sync="pagination.pageSize"
          :total="pagination.total"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
    <Dialoglist
      :exhibitid="exhibitid"
      :dialogtype="'ask'"
      :dialogFormVisible="dialogFormVisible"
      @handleCloseDialog="handleCloseDialog"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { EventBus } from "../EventBus";

import ExhibitService from "../services/exhibit";

import Dialoglist from "@/components/dialoglist";
import { getExhibitPage, getOnlineShowBanners } from "../http/api";
import { getHotExhibits } from "../http/api";
import { getExhibitCategory } from "../http/api";
import { getVenue } from "../http/api";
import { getExhibitPageList } from "../http/api";

export default {
  components: {
    Dialoglist
  },
  data() {
    // let categoryId = null;
    // if (this.$route.query["exhibitCategory.id"]) {
    //   categoryId = this.$route.query["exhibitCategory.id"];
    // }
    return {
      value: "E1",
      currentName: "",
      dialogFormVisible: false,
      exhibitid: "",
      // 广告
      advertisements: [],
      // 排序
      sorters: [
        {
          lable: this.$t("Default"),
          value: "sequence"
        },
        {
          lable: this.$t("Latest"),
          value: "create_time"
        }
      ],
      // 分类
      categories: [],
      category: {
        // categoryId
      },
      // 展馆
      venues: [],
      // 数据服务
      service: ExhibitService,
      // 初始参数绑定
      entity: {
        enabled: true,
        approved: true,
        approveResult: "APPROVED"
      },
      // 查询参数绑定
      filters: {
        categoryId: null,
        venueId: null
      },
      // 查询排序参数绑定
      sorter: {
        field: "sequence",
        order: "DESC"
      },
      // 页面数据
      entities: [],
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 12,
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      }
    };
  },
  computed: {
    ...mapGetters({
      hasAuthentication: "hasAuthentication",
      hasCollected: "hasCollected",
      hasLiked: "hasLiked"
    })
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        window.scrollTo(0, 0);
        this.filters.language = this.$i18n.locale == "zh" ? "ZH" : "EN";

        if (this.$route.query.key) {
          this.filters.name = this.$route.query.key;
        }

        if (this.$route.query["exhibitCategory.id"]) {
          const category = { id: this.$route.query["exhibitCategory.id"] };

          this.filters.categoryId = category.id;

          this.category = category;
        }

        if (this.$route.query["key"]) {
          this.filters.name = this.$route.query["key"];
        }

        this.handleParamChange();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      addCollected: "addCollected",
      deleteCollected: "deleteCollected",
      addLiked: "addLiked",
      deleteLiked: "deleteLiked"
    }),
    async handleAdvertisementClick(advertisement) {
      if (advertisement.type == "BANNER" && advertisement.link) {
        window.open(advertisement.link);
      }
    },
    handleExhibitClick(exhibit) {
      this.$router.push(`/exhibit/${exhibit.id}`);
    },
    async handleItemClick(category) {
      console.log(category);

      this.category = { id: category.id };
      this.filters.categoryId = this.category.id;
      this.handleParamChange();
    },
    handleCloseDialog(is) {
      this.dialogFormVisible = is;
    },
    setexhibitid(id) {
      this.dialogFormVisible = true;
      this.exhibitid = id;
    },
    // -------------------------------------------------------------------------------------------------
    // 询盘点击事件
    handleInquiryClick(exhibit) {
      if (!this.hasAuthentication()) {
        this.$router.push("/login");
        return;
      }

      this.exhibitid = exhibit.id;
      this.dialogFormVisible = true;
    },
    async handleCollectClick(type, id, status, event) {
      if (event) {
        event.stopPropagation
          ? event.stopPropagation()
          : (event.cancelBubble = true);
      }

      if (status) {
        // 已经收藏
        await this.deleteCollected({
          type: type,
          id: id
        });
      } else {
        //收藏
        await this.addCollected({
          type: type,
          id: id
        });
      }
    },
    async handleLikeClick(type, id, status) {
      if (status) {
        // 已经收藏
        await this.deleteLiked({
          type: type,
          id: id
        });
      } else {
        //收藏
        await this.addLiked({
          type: type,
          id: id
        });
      }
    },
    handleParamChange() {
      this.pagination.current = 1;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },
    handlePageChange(page) {
      this.pagination.current = page;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },

    async getAdvertisements() {
      const result = await getOnlineShowBanners();
      const getHot = await getHotExhibits();

      this.advertisements = [...result, ...getHot.content];

      this.advertisements = this.advertisements.map(advertisement => {
        advertisement.liked = this.hasLiked("EXHIBIT", advertisement.id);

        advertisement.collected = this.hasCollected(
          "EXHIBIT",
          advertisement.id
        );

        if (advertisement.exhibitor) {
          advertisement.exhibitor.liked = this.hasLiked(
            "EXHIBITOR",
            advertisement.exhibitor.id
          );

          advertisement.exhibitor.collected = this.hasCollected(
            "EXHIBITOR",
            advertisement.exhibitor.id
          );
        }
        return advertisement;
      });
      console.log(
        "🚀 ~ file: onlineshow.vue:465 ~ getAdvertisements ~  this.advertisements:",
        this.advertisements
      );
    },
    async getVenues() {
      const result = await getVenue();
      this.venues = [
        {
          id: null,
          enabled: true,
          sequence: 10,
          number: null,
          name: "全部",
          nameEn: "All"
        },
        ...result
      ];
      console.log(this.venues);
    },

    async getCategories() {
      const result = await getExhibitCategory({ size: 99 });
      this.categories = result.toTree().slice(0, 11);
      this.categories.push({
        name: "全部产品",
        nameEn: "ALL",
        icon: require("../assets/images/online_bicycle12.png")
      });
    },
    async getEntityPage(entity, pagination, filters, sorter) {
      if (filters) {
        for (const key in filters) {
          const param = filters[key];
          entity[key] = param;
        }
      }

      const pageable = {
        page: pagination.current - 1,
        size: pagination.pageSize
      };

      if (sorter) {
        pageable.sort = `${sorter.field} ${
          sorter.order ? sorter.order : "DESC"
        }`;
      }
      const result = await getExhibitPageList(entity, {
        ...pageable,
        isUp: true
      });
      this.entities = result.content;
      this.pagination.current = result.number + 1;
      this.pagination.total = result.totalElements;
    }
  },
  mounted() {
    this.filters.language = this.$i18n.locale == "zh" ? "ZH" : "EN";

    if (this.$route.query.key) {
      this.filters.key = this.$route.query.key;
    }

    if (this.$route.query["exhibitCategory.id"]) {
      const category = { id: this.$route.query["exhibitCategory.id"] };

      this.filters.categoryId = category.id;

      this.category = category;
    }

    if (this.$route.query["key"]) {
      this.filters.key = this.$route.query["key"];
    }

    this.getAdvertisements();
    this.getCategories();
    this.getVenues();
    this.getEntityPage(this.entity, this.pagination, this.filters, this.sorter);

    EventBus.$on("setLiked", () => {
      this.advertisements = this.advertisements.map(advertisement => {
        advertisement.liked = this.hasLiked("EXHIBIT", advertisement.id);

        return advertisement;
      });
    });

    EventBus.$on("setCollected", () => {
      this.advertisements = this.advertisements.map(advertisement => {
        advertisement.collected = this.hasCollected(
          "EXHIBIT",
          advertisement.id
        );

        return advertisement;
      });
    });
  }
};
</script>
<style lang="less" scoped>
.online-container {
  background: #eaeaea;

  .container {
    width: 1200px;
    margin: 0 auto;
  }
}

.online-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // justify-content: space-between;
}

.online-item:hover .online-item-comp {
  background: #619a37;
  color: #ffffff;
}

.online-item:hover .online-item-top {
  transform: scale(1.1);
}

.online-item:hover .online-item-name {
  transform: scale(1.1);
}

.online-item:nth-child(4n) {
  margin-right: unset;
}

.online-item {
  width: 277px;
  height: 372px;
  background: #fff;
  margin-bottom: 30px;
  cursor: pointer;
  margin-right: 30px;

  .online-item-top {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    align-items: center;

    .online-item-img {
      width: 278px;
      height: 272px;
      display: flex;
      align-items: center;
      justify-content: center;

      .online-icon-recom {
        max-width: 88%;
        max-height: 88%;
      }
    }

    .online-item-name {
      // width: 100%;
      font-size: 14px;
      font-family: FZLanTingHeiS-DB1-GBK;
      font-weight: 400;
      color: #444444;
      text-align: center;
      line-height: 53px;
      // padding: 18px 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 80%;
      align-items: center;
    }
  }

  .online-item-comp {
    width: 100%;
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #999999;
    height: 46px;
    width: 100%;
    text-align: center;
    line-height: 46px;
    border-top: 1px solid #dddddd;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }
}

.online-sort-title {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #444444;
  margin-right: 10px;
}

.online-header-list {
  display: flex;
  flex-direction: row;
  width: 628px;
  height: 399px;
  margin-top: 40px;
  flex-wrap: wrap;

  .online-header-item {
    width: 157px;
    height: 133px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #333333;
    cursor: pointer;

    .online-header-img {
      width: 157px;
      height: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        height: 56px;
      }
    }

    .online-header-text {
      text-align: center;
      font-size: 14px;
      font-family: FZLanTingHeiS-DB1-GBK;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.online-header-item:hover,
.online-header-list .onlineActive {
  background: #619a37;
}

/deep/ .online-swiper .el-carousel__container {
  height: 399px !important;
  width: 572px;
}

/deep/ .el-carousel__arrow--left {
  left: unset;
  right: 60px;
  top: 40px;
}

/deep/ .el-carousel__arrow--right {
  left: unset;
  right: 20px;
  top: 40px;
}

/deep/ .el-carousel__arrow {
  border-radius: unset;
}

/deep/ .el-carousel__arrow:hover {
  background: #619a37;
}

.online-header-swiper {
  margin-top: 40px;
  background: #ffffff;
}

.online-siper-detail {
  padding: 100px 15px 30px 15px;
  height: 100%;
  width: 250px;
  box-sizing: border-box;

  .online-siper-name {
    font-size: 18px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #444444;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .online-siper-comp {
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    font-weight: 400;
    color: #999999;
    margin-top: 16px;
    margin-bottom: 14px;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }

  .online-siper-btnlist {
    p {
      width: 58px;
      height: 30px;
      background: #619a37;
      border-radius: 2px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 4px;
    }
  }

  .online-swiper-line {
    width: 100px;
    height: 1px;
    background: #999999;
    margin: 20px 0;
  }

  .online-siper-desc {
    font-weight: 400;
    color: #444444;
    font-size: 14px;
    font-family: FZLanTingHeiS-DB1-GBK;
    line-height: 24px;
    overflow-y: scroll;
    // height: 120px;
    text-align: justify;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; //作为弹性伸缩盒子模型显示。
    -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
    -webkit-line-clamp: 4; //显示的行
  }
}

.online-header-left {
  height: 100%;

  .online-header-tag {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    .online-icon-recom {
      width: 101px;
      height: 101px;
    }

    .online-hot-view {
      color: #fff;
      width: 0;
      height: 0;
      border-width: 70px;
      border-style: solid;
      border-color: red transparent transparent transparent;
      overflow: hidden;
      font-size: 0;
      line-height: 0;
      transform: rotate(135deg);
      margin: -70px 0 0 -70px;
    }
    .online-hot-text {
      color: #fff;
      font-weight: 700;
      transform: rotate(-45deg);
      font-size: 15px;
      margin-top: 24px;
      position: absolute;
      width: 70px;
      text-align: center;
    }

    .online-icon-new {
      width: 50px;
      height: 38px;
      margin-top: 20px;
    }
  }

  .online-swiper-img {
    margin: -8px 0 0 10px;
  }
}

.checkall {
  font-size: 14px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #444444;
  padding: 8px 24px;
  background: #ffffff;
  border: 1px solid #dddddd;
  cursor: pointer;
}

/deep/ .el-select {
  .el-input__inner {
    height: 30px !important;
    line-height: 30px;
  }
  .el-input__prefix,
  .el-input__suffix {
    top: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/onlineshow.vue